<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/1.4.6/tailwind.min.css">

<app-header 
  [fixed]="true"
  [navbarBrandFull]="{src: 'assets/img/brand/logowh.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [navbarBrandMinimized]="{src: 'assets/img/brand/logowh.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [sidebarToggler]="false"
  [mobileSidebarToggler]="false"
  [asideMenuToggler]="false"
  [mobileAsideMenuToggler]="false"
  >
  
    <!-- Dropdown Menu -->
    <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" dropdown placement="bottom right">

      <a class="nav-link" style="color:white" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
         Mon Compte  <i  style style="padding-left:5px" class="icon-user icons"></i>&nbsp;&nbsp;
      </a>

      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong >Bonjour {{email$}}</strong></div>
        <a (click)="GotoSupport()" class="dropdown-item" ><i class="fa fa-question-circle"></i>Support</a>
        <a (click)="logout(mymodal)" class="dropdown-item" ><i class="fa fa-sign-out"></i>Se déconnecter</a>

        <!-- model start here  -->
        <ng-template #mymodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title" style="color:#6600ff; font-weight: bold; font-size: 18px;">DÉCONNEXION</h4>
            <button type="button" class="close"    aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" style="font-size: 16px;">
            Êtes-vous sûr de quitter Robo Advisor ?
           </div>
          <div class="modal-footer">
           
            <button type="button" class="btn modele2" data-dismiss="modal" (click)="modal.dismiss('Cross click')" >Fermer</button>
            <button type="button" class="btn  modele" data-dismiss="modal" (click)="modal.close('Save click'); signout();">Confirmer</button>
            <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button> -->
          </div>
        </ng-template>
        <!-- model End here  -->

        <!-- <ng-template >
          <a class="dropdown-item"  [routerLink]="['/']" routerLinkActive="router-link-active"><i class="fa fa-unlock"></i>Se connecter</a>
        </ng-template> -->
        <!-- <a class="dropdown-item"><i class="fa fa-user"></i>Mon profil</a>
        <a class="dropdown-item" [routerLink]="['/auth/info']" routerLinkActive="router-link-active" ><i class="fa fa-wrench"></i>Auth Debug</a> -->
      </div>
      
    </li>
  </ul>
 
</app-header>
<div class="sub">
<div class="pricing-table-2 ">



    <div class="container mx-auto px-4">
  
      <div class="max-w-3xl mx-auto text-center">
        <h1 class="tex1">Plans d'abonnement</h1>
        <p class="tex">Vous avez le choix entre trois plans pour bénificier des services du ROBO-ADVISOR. </p>
      </div>

      <div class="pricing-plans lg:flex lg:-mx-4 mt-6 md:mt-12">
  
        <div class="pricing-plan-wrap lg:w-1/3 my-4 md:my-6">
          <div class="pricing-plan  text-center max-w-sm mx-auto  transition-colors duration-300">
            <div class="p-6 md:py-8">
              <h4 class="font-medium leading-tight text-2xl mb-2">Basic</h4>
              <p class="text-gray-600">Pour les projets ponctuels</p>
            </div>
            <div class="pricing-amount p-6 transition-colors duration-300">
              <div class=""><span class="text-4xl font-semibold">1 </span> TND</div>
            </div>
            <div class="p-6">
              <ul class="leading-loose">
                <li>Accés d'un jour pour:</li>
                <li>Résumé du Marché </li>
                <li>Suivi des Actions</li>
                <li>Suivi des OPCVMS</li>
                <li>Meilleurs conseils du jour</li>
              </ul>
              <div class="mt-6 py-4">
                <button (click)="basicplan()" class="text-xl text-white py-2 px-6 rounded hover:bg-indigo-700 transition-colors duration-300">S'abonner</button>
              </div>
            </div>
          </div>
        </div>
  
        <div class="pricing-plan-wrap lg:w-1/3 my-4 md:my-6">
          <div class="pricing-plan  text-center max-w-sm mx-auto hover:border-indigo-600 transition-colors duration-300">
            <div class="p-6 md:py-8">
              <h4 class="font-medium leading-tight text-2xl mb-2">Advanced</h4>
              <p class="text-gray-600">Pour les projets courts</p>
            </div>           
             <div class="pricing-amount p-6 transition-colors duration-300">
              <div><span class="text-4xl font-semibold">5 </span> TND</div>
            </div>
            <div class="p-6">
              <ul class="leading-loose">
                <li>Accés de 7 jours pour:</li>
                <li>Résumé du Marché </li>
                <li>Suivi des Actions</li>
                <li>Suivi des OPCVMS</li>
                <li>Meilleurs conseils du jour</li>
              </ul>
              <div class="mt-6 py-4">
                <button (click)="intermediateplan()" class="text-xl text-white py-2 px-6 rounded hover:bg-indigo-700 transition-colors duration-300">S'abonner</button>
              </div>
            </div>
          </div>
        </div>
  
        <div class="pricing-plan-wrap lg:w-1/3 my-4 md:my-6">
          <div class="pricing-plan  text-center max-w-sm mx-auto hover:border-indigo-600 transition-colors duration-300">
            <div class="p-6 md:py-8">
              <h4 class="font-medium leading-tight text-2xl mb-2">Professional</h4>
              <p class="text-gray-600">Pour les projets à grande échelle</p>
            </div>
            <div class="pricing-amount p-6 transition-colors duration-300">
              <div class=""><span class="text-4xl font-semibold">10 </span> TND</div>
            </div>
            <div class="p-6">
              <ul class="leading-loose">
                <li>Accés d'un mois pour:</li>
                <li>Résumé du Marché </li>
                <li>Suivi des Actions</li>
                <li>Suivi des OPCVMS</li>
                <li>Meilleurs conseils du jour</li> 
              </ul>
              <div class="mt-6 py-4">
                <button (click)="advancedplan()" class="text-xl text-white py-2 px-6 rounded hover:bg-indigo-700 transition-colors duration-300">S'abonner</button>
              </div>
            </div>
          </div>
        </div>
  
      </div>
  
    </div>
  </div>
</div>